import _ from 'lodash';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import classNames from 'classnames';

import { isNew } from '@/helpers/HelperFunctions';

const AppTemplate = ({ app, locale = "de" }) => {
    const { t } = useTranslation('apps');

    const cardClasses = classNames('col-12 col-md-6', {
        'col-xl-4': !app.isOwned
    });

    return (
        <div className={cardClasses}>
            {/*<!-- Card -->*/}
            <div className="card card-fill">
                <div className="card-body mt-0">

                    {/*<!-- Logo -->*/}
                    <Link href={`/apps/${encodeURIComponent(app.slug)}`}>
                        {app.logo?.formats ?
                            // App Logo
                            <a className="card-app-logo mb-4"><img src={app.logo.formats.small?.url || app.logo.formats.thumbnail?.url} className="product-img" alt={app.name} /></a>
                            // or Partner Logo
                            : <a className="card-app-logo mb-4"><img src={app.partner.logo.formats.thumbnail.url} className="product-img" alt={app.name} /></a>
                        }
                    </Link>

                    {/*<!-- Category -->*/}
                    {app.category?.name &&
                        <span className="badge bg-primary-soft mb-3">{app.category.name}</span>
                    }

                    {/*<!-- Title -->*/}
                    <h2 className="card-title">
                        <Link href={`/apps/${encodeURIComponent(app.slug)}`}>
                            <a className="d-block hyphen">{app.name}</a>
                        </Link>
                        <small className="text-muted">{app.partner.name}</small>
                    </h2>

                    {/*<!-- Text -->*/}
                    <p className="card-text small">
                        {app[`description_short_${locale}`]}
                    </p>

                </div>
                <div className="card-footer card-footer-boxed">
                    <div className="row align-items-center">
                        <div className="col">
                            {app.coming_soon &&
                                <span className="badge badge-soft-secondary">Coming soon</span>
                            }
                            {(!app.coming_soon && isNew(app.published_at)) &&
                                <span className="badge badge-soft-success">{t('new')}</span>
                            }
                        </div>
                        <div className="col-auto">
                            {app.isOwned &&
                                <a href={app.app_url || '#'} className="btn btn-success" target="_blank">
                                    <i className="fe fe-external-link mr-1"></i> {t('open')}
                                </a>
                            }
                            {!app.isOwned &&
                                <Link href={`/apps/${encodeURIComponent(app.slug)}`}>
                                    <a className="btn btn-primary btn-sm">{t('details')}</a>
                                </Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppTemplate;
